import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { MDBBtn } from "mdbreact";
import { scrollTop } from "../../../functions";

import { formatDayMonth } from "../../../utils/formatDate";

import "./styles.css";

const BlogCard = ({ img, date, title, subtitle, path }) => {
  return (
    <div className="blog-card">
      <img src={img} className="card-image" alt="thumbnail" />
      <div className="date">
        <strong>{formatDayMonth(date || "2020-06-16")}</strong>
      </div>
      <div className="blog-caption">
        <h3>{title}</h3>
        <p>{subtitle}</p>
        <Link to={path} onClick={scrollTop} id="blog-card-link">
          {" "}
          <MDBBtn color="red">SAIBA MAIS</MDBBtn>
        </Link>
      </div>
    </div>
  );
};

BlogCard.propTypes = {
  img: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default BlogCard;
